var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.908 53.6512C22.1096 53.6512 14.6306 50.8249 9.11626 45.7941C3.60194 40.7634 0.504028 33.9402 0.504028 26.8256C0.504028 19.711 3.60194 12.8878 9.11626 7.85703C14.6306 2.82626 22.1096 0 29.908 0C37.7065 0 45.1855 2.82626 50.6998 7.85703C56.2141 12.8878 59.3121 19.711 59.3121 26.8256C59.3121 33.9402 56.2141 40.7634 50.6998 45.7941C45.1855 50.8249 37.7065 53.6512 29.908 53.6512ZM33.0212 26.3394C35.0583 25.6707 36.7716 24.3678 37.8593 22.6601C38.947 20.9523 39.3394 18.9493 38.9674 17.0035C38.5954 15.0578 37.4829 13.2941 35.8257 12.0232C34.1686 10.7522 32.073 10.0553 29.908 10.0553C27.7431 10.0553 25.6475 10.7522 23.9904 12.0232C22.3332 13.2941 21.2207 15.0578 20.8487 17.0035C20.4767 18.9493 20.8691 20.9523 21.9568 22.6601C23.0445 24.3678 24.7578 25.6707 26.7949 26.3394C20.6127 27.7008 15.206 32.7775 15.206 36.8852C15.206 38.2097 15.739 40.2216 18.8815 40.2216H40.9345C44.0771 40.2216 44.61 38.2097 44.61 36.8852C44.61 32.7809 39.2071 27.6974 33.0212 26.3394Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.808,
    height: 53.6512,
    fill: "white",
    transform: "translate(0.504028)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.902f987bb74cf5f046633e6011d3a9d4.svg";
export { ForwardRef as ReactComponent };